'use client';

import { useMutation } from '@tanstack/react-query';
import Axios from '@/lib/axiosConfig';
import { useAuth } from '@/context/Auth';

interface PromotePostResponse {
  success: boolean;
  message: string | null;
  // Stripe checkout URL (same shape as the partnership upgrade endpoint).
  responseObject: string;
  statusCode: number;
}

export const usePromotePost = () => {
  const { getAPIRequestTokenHeaders } = useAuth();

  return useMutation<PromotePostResponse, Error, { postID: string }>({
    mutationFn: async ({ postID }) => {
      const res = await Axios.post(
        `/posts/${postID}/promote`,
        {},
        { headers: getAPIRequestTokenHeaders() }
      );
      return res.data;
    },
  });
};

// Called when promoting a post fails because the user has no ad credits
// (the promote endpoint returns a 400). Returns a Stripe checkout URL.
export const usePurchaseAdsCredits = () => {
  const { getAPIRequestTokenHeaders } = useAuth();

  return useMutation<PromotePostResponse, Error, void>({
    mutationFn: async () => {
      const res = await Axios.post(
        `/users/credits/ads/purchase`,
        {},
        { headers: getAPIRequestTokenHeaders() }
      );
      return res.data;
    },
  });
};
